import PropTypes from "prop-types";
import { childrenPropType, displayPropType, classNamePropType } from "../../common";

/**
 * PropTypes for Container component
 *
 * @property {React.ReactNode} children - Child elements to render within the container
 * @property {('flex'|'grid')} [display] - Display type ('flex' or 'grid')
 * @property {string} [className] - Additional CSS class names
 * @property {number} [gap] - Gap size in pixels for both column and row spacing
 */
export const containerPropTypes = {
  children: childrenPropType,
  display: displayPropType,
  className: classNamePropType,
  gap: PropTypes.number,
};
